/** Product pages load optional feature definitions only when their markup exists.
 * Core gallery, variants, prices, forms, cart and navigation remain eager modules.
 * Observe added subtrees so recommendations, morphs and editor sections still work.
 */
const configuration = document.getElementById('product-optional-features');
if (configuration) {
  const features = new Map(Object.entries(JSON.parse(configuration.textContent || '{}')));
  const pending = new Set();
  const failedAt = new Map();
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node instanceof Element) scan(node);
    }
  });

  function scan(root) {
    for (const [tag, url] of features) {
      if (customElements.get(tag)) { features.delete(tag); continue; }
      if (pending.has(tag) || Date.now() - (failedAt.get(tag) || 0) < 10000) continue;
      if (!(root instanceof Element && root.matches(tag)) && !root.querySelector(tag)) continue;
      pending.add(tag);
      import(url).then(() => {
        features.delete(tag);
        if (!features.size) observer.disconnect();
      }).catch(() => {
        // A transient module failure can retry on a later insertion or intent.
        failedAt.set(tag, Date.now());
      }).finally(() => pending.delete(tag));
    }
    if (!features.size) observer.disconnect();
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('focusin', (event) => {
    if (failedAt.size && event.target instanceof Element) scan(event.target.parentElement || event.target);
  }, { passive: true });
}
